import { authState } from "./authState";
import { mainPageState } from './mainPageState';
import { filterMainPageState } from './filterMainPageState';

export const rootState = {
    auth: authState,
    mainPage: mainPageState,
    filterMainPage: filterMainPageState,
}